import { useReducer } from 'react';

import type { TModalNames } from 'components/organisms/rpm-alert-assessment-modal/types';

const toggleFn = (state: boolean) => !state;

export const useOpenAssessmentModal = () => {
  const [isOpenWeight, toggleOpenWeight] = useReducer(toggleFn, false);
  const [isOpenChfWeight, toggleOpenChfWeight] = useReducer(toggleFn, false);
  const [isOpenPulse, toggleOpenPulse] = useReducer(toggleFn, false);
  const [isOpenPressure, toggleOpenPressure] = useReducer(toggleFn, false);
  const [isOpenGlucose, toggleOpenGlucose] = useReducer(toggleFn, false);
  const [isOpenSpo2, toggleOpenSpo2] = useReducer(toggleFn, false);
  const [isOpenMaCritical, toggleMaCritical] = useReducer(toggleFn, false);

  const toggleAssessmentModal = (modalName: TModalNames) => {
    if (modalName === 'weight') {
      toggleOpenWeight();
    }
    if (modalName === 'chfWeight') {
      toggleOpenChfWeight();
    }
    if (modalName === 'pulse') {
      toggleOpenPulse();
    }
    if (modalName === 'pressure') {
      toggleOpenPressure();
    }
    if (modalName === 'glucose') {
      toggleOpenGlucose();
    }
    if (modalName === 'spo2') {
      toggleOpenSpo2();
    }
    if (modalName === 'maCritical') {
      toggleMaCritical();
    }
  };

  const isOpenAssessmentModalMap: Record<TModalNames, boolean> = {
    weight: isOpenWeight,
    chfWeight: isOpenChfWeight,
    pulse: isOpenPulse,
    pressure: isOpenPressure,
    glucose: isOpenGlucose,
    spo2: isOpenSpo2,
    maCritical: isOpenMaCritical,
  };

  return {
    toggleAssessmentModal,
    isOpenAssessmentModalMap,
  };
};
